import axios from "axios";
import { getBrowserCDDC } from "../utils/identity-utils";
import URL from "../utils/urls";

export async function userLogin(email: string, location: string): Promise<any> {
    const response = await axios.post(
        URL.identity.login, 
        { email, location }
    );
    return response;
}

export async function validateOTL(otlToken: string): Promise<any> {
    const { data } = await axios.post(
        URL.identity.validateOTL,
        { otlToken }
    );

    return data;
}

export async function triggetOTP(otlToken: string, idToken: string, countryCode: string, phoneNumber: any, browserCDDC: any): Promise<any> {
    const response = await axios.post(
        URL.identity.triggerOTP,
        { 
            otlToken,
            idToken,
            countryCode,
            phoneNumber,
            browserCDDC
        }
    );
    return response;
}

export async function validateOTP(otlToken: string, idToken: string, otp: string, browserCDDC: any): Promise<any> {
    const {data} = await axios.post(
        URL.identity.validateOTP,
        {
            otlToken,
            idToken,
            otp,
            browserCDDC: browserCDDC
        }
    );
    return data;
}

export async function sessionAlive(): Promise<any> {
    return await axios.get(URL.identity.alive);
}